module.exports = __webpack_public_path__ + "static/media/yoga.2c947b26.gif";